<template>
    <ul id="distributRecord">
        <mt-loadmore :bottom-method="getSimDistributRecordHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <li v-for="item in records" :key="item.id" class="oneRecord">
                <ul>
                    <li>
                        <label>开始ICCID</label>
                        <span>{{item.startIccid}}</span>
                    </li>
                    <li>
                        <label>结束ICCID</label>
                        <span>{{item.endIccid}}</span>
                    </li>
                    <li>
                        <label>分销商</label>
                        <span>{{item.agentName}}</span>
                    </li>
                    <li>
                        <label>分销时间</label>
                        <span>{{item.createTime}}</span>
                    </li>
                </ul>
            </li>
        </mt-loadmore>
    </ul>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            records: [],
            pageNo: 0,
            perPageNum: 5,
            allPage: 0,
            allLoaded: false
        }
    },
    methods: {
        getSimDistributRecordHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                perPageNum: this.perPageNum
            }
            wxRequest("sim/soldRecord/listPage", data, "post").then(res => { 
                if(res.data.code == 200){
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }

                    this.records = this.records.concat(res.data.data.resultList)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                    
                }
            })
        }
    },
    created(){
        this.getSimDistributRecordHandler();
    }
}
</script>
<style lang="less" scoped>
ul#distributRecord {
    min-height: 100%;
    background: #f2f2f2;
    padding: 10px 3%;
    box-sizing: border-box;
    li.oneRecord {
        background: #fff;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 10px;
        ul li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eaeaea;
            display: flex;
            justify-content: space-between;
            span {
                color: #a0a0a0;;
            }
            &:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>

